<template>
  <div v-if="cardData?.width === '50'" class="card-article half" :class="{ 'has-background' : cardData?.image?.url}"
    :style="{ 'background-image': `url(${cardData?.image?.url})` }">
    <component :is="type === 'normal' ? 'h3' : 'p'" class="card-title">
      <a :target="wordingTypeContent(cardData.type).target" :href="wordingTypeContent(cardData.type).link">
        {{ wordingTypeContent(cardData.type).title }}
      </a>
    </component>
    <a class="btn-arrow" :class="{ 'card-btn': wordingTypeContent(cardData.type).target === '_blank' }"
      :target="wordingTypeContent(cardData.type).target" :href="wordingTypeContent(cardData.type).link">
      <span class="txt">{{ ((typeof(cardData.source) === 'undefined' || cardData.source === null) &&
      wordingTypeContent(cardData.type).target ==='_blank' ) ? 'Lien externe' : wordingTypeContent(cardData.type).text
      }}</span>
    </a>
  </div>
  <div
    v-else
    :class="['card-article',
        { 'has-data': cardData.read_time || cardData.read_difficulty || cardData.date || cardData.source },
        { 'has-pic': cardData?.image?.url },
        { 'is-tagged': cardData.region },
        { 'is-mobile': isMobile && !(cardData.read_time || cardData.read_difficulty || cardData.date || cardData.source) }
      ]">
    <span v-if="cardData.region" class="card-tag">En région</span>
    <div v-if="cardData.image && !isMobile" class="card-pic">
      <img :src="cardData?.image?.url" :alt="cardData?.image?.alt" />
    </div>
    <component :is="type === 'normal' ? 'h3' : 'p'" class="card-title">
      <a :target="wordingTypeContent(cardData.type).target" :href="wordingTypeContent(cardData.type).link">
        {{ wordingTypeContent(cardData.type).title }}
      </a>
    </component>
    <p class="card-desc" v-if="cardData.chapo" v-html="$sanitize(cardData.chapo)"></p>
    <div v-if="cardData.read_time || cardData.read_difficulty" class="card-data">
      <div class="card-infos">
        <i v-if="cardData.read_time" class="icon icon-clock" aria-hidden="true"></i>
        <p v-if="cardData.read_time" class="card-time">{{ readTime }}</p>
        <div v-if="cardData.read_difficulty" class="level">
          <i
            v-for="i in 5"
            class="level-circle"
            :class="{ 'is-full': expertRating(cardData.read_difficulty) >= i }"
            :key="'star_key_' + cardData.nid + i"
            aria-hidden="true"
          ></i>
          <span class="level-txt">{{ cardData.read_difficulty }}</span>
        </div>
      </div>
      <div v-if="cardData.date || cardData.source" class="card-refs">
        <p v-if="cardData.date">Publié le <span class="card-date">{{ cardData.date }}</span></p>
        <p v-if="cardData.source">Proposé par <span class="card-author">{{ cardData.source }}</span></p>
      </div>
    </div>
    <a class="btn-arrow"
      :class="{ 'card-btn': wordingTypeContent(cardData.type).target === '_blank' }"
      :target="wordingTypeContent(cardData.type).target" :href="wordingTypeContent(cardData.type).link">
      <span class="txt">{{ ((typeof(cardData.source) === 'undefined' || cardData.source === null) &&
      wordingTypeContent(cardData.type).target ==='_blank' ) ? 'Lien externe' :
      wordingTypeContent(cardData.type).text }}</span>
    </a>
  </div>
</template>

<script>
import { computed, inject } from 'vue';

export default {
  props: {
    cardData: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: () => 'normal',
    },
  },
  setup(props) {
    const isMobile = inject('isScreenMdMin');

    function wordingTypeContent(type) {
      let lien = {
        title: '', text: '', target: '', link: '',
      };
      switch (type) {
        case 'info_sheet':
          lien = {
            title: props.cardData.title, text: 'lire article', target: '_self', link: props.cardData.url,
          };
          return lien;

        case 'dossier_thematic':
          lien = {
            title: props.cardData.title, text: 'lire le dossier', target: '_self', link: props.cardData.url,
          };
          return lien;

        case 'ext_links':
          lien = {
            title: props.cardData.title, text: `Lire sur ${props.cardData.source}`, target: '_blank', link: props.cardData.external_link,
          };
          return lien;

        case 'video':
          lien = {
            title: props.cardData.title, text: 'voir video', target: '_self', link: props.cardData.url,
          };
          return lien;

        default:
          return '';
      }
    }

    // to redo
    const expertRating = function readDifficulty(type) {
      switch (type) {
        case 'Facile':
          return 1;

        case 'Moyen':
          return 3;

        case 'Difficile':
          return 4;

        case 'Expert':
          return 5;

        default:
          return 0;
      }
    };

    const readTime = computed(() => {
      // Prevent reindex back and apply RG in front
      if (props.cardData && props.cardData.read_time) {
        let str = props.cardData.read_time;
        str = str.replace('Plus de', '+');
        str = str.replace('minutes', 'min');
        str = str.replace('minute', 'min');
        str += ' de lecture';

        return str;
      }

      return false;
    });

    return {
      isMobile,
      wordingTypeContent,
      expertRating,
      readTime,
    };
  },
};

</script>
